/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RptSalPlannedMeseAnnoImportoOutputDtoFromJSON, RptSalPlannedMeseAnnoImportoOutputDtoToJSON, } from './RptSalPlannedMeseAnnoImportoOutputDto';
/**
 * Check if a given object implements the RptSalPlannedOutputDto interface.
 */
export function instanceOfRptSalPlannedOutputDto(value) {
    return true;
}
export function RptSalPlannedOutputDtoFromJSON(json) {
    return RptSalPlannedOutputDtoFromJSONTyped(json, false);
}
export function RptSalPlannedOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pkSal': json['pkSal'] == null ? undefined : json['pkSal'],
        'pkProgetto': json['pkProgetto'] == null ? undefined : json['pkProgetto'],
        'denominazioneProgetto': json['denominazioneProgetto'] == null ? undefined : json['denominazioneProgetto'],
        'denominazioneBlocco': json['denominazioneBlocco'] == null ? undefined : json['denominazioneBlocco'],
        'pkTipologiaBlocco': json['pkTipologiaBlocco'] == null ? undefined : json['pkTipologiaBlocco'],
        'rptSalPlannedMeseAnnoImportoOutputDtoList': json['rptSalPlannedMeseAnnoImportoOutputDtoList'] == null ? undefined : (json['rptSalPlannedMeseAnnoImportoOutputDtoList'].map(RptSalPlannedMeseAnnoImportoOutputDtoFromJSON)),
    };
}
export function RptSalPlannedOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'pkSal': value['pkSal'],
        'pkProgetto': value['pkProgetto'],
        'denominazioneProgetto': value['denominazioneProgetto'],
        'denominazioneBlocco': value['denominazioneBlocco'],
        'pkTipologiaBlocco': value['pkTipologiaBlocco'],
        'rptSalPlannedMeseAnnoImportoOutputDtoList': value['rptSalPlannedMeseAnnoImportoOutputDtoList'] == null ? undefined : (value['rptSalPlannedMeseAnnoImportoOutputDtoList'].map(RptSalPlannedMeseAnnoImportoOutputDtoToJSON)),
    };
}
